export default {
	messageType: 'navigation',
	type: 'conversationMessage',
	url: '',
	bidirectional: '',
	recipients: null,
	createdAt: null,
	speaker: null
}
